import Layout from '@plat/views/event/registration/Layout'
import Registration from '@plat/views/event/registration/Registration'
import RegistrationResponse from '@plat/views/event/registration/RegistrationResponse'

export default [
  {
    path: '/',
    component: Layout,
    children: [{
      path: '/',
      component: Registration,
      name: 'registrationForm'
    }, {
      path: 'fullcapacity',
      component: Registration,
      name: 'registrationFormFullCapacity'
    }, {
      path: 'attendee/:attendeeId/success',
      component: RegistrationResponse,
      name: 'registrationSuccess'
    }, {
      path: 'closed',
      component: RegistrationResponse,
      name: 'registrationExpired'
    }, {
      path: 'waitinglist',
      component: RegistrationResponse,
      name: 'registrationWaitingList'
    }]
  }
]
